import { DescriptionField, descriptionFieldCopy } from "@/components/ListingFields/DescriptionField";
import { EditorSection } from "@/components/ListingFields/EditorSectionHeader";

const LISTING_TYPE = "service" as const;

export interface ServiceDescriptionEditorProps {
  /** Field error for the description, or undefined when valid. */
  error?: string;
  /** Called with the new HTML on every change. */
  onChange: (html: string) => void;
  /** Current description, as HTML. */
  value: string;
}

export function ServiceDescriptionEditor({ error, onChange, value }: ServiceDescriptionEditorProps) {
  return (
    <EditorSection {...descriptionFieldCopy(LISTING_TYPE)}>
      <DescriptionField error={error} listingType={LISTING_TYPE} onChange={onChange} value={value} />
    </EditorSection>
  );
}
